import { ExternalLinkIcon } from 'lucide-react'

import { assets } from '@/ui/assets'
import { ExternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { Panel } from '@/ui/atoms/panel/Panel'
import { links } from '@/ui/constants/links'

export function ParticipateInDaoBanner() {
  return (
    <Panel spacing="none" variant="secondary" className="relative isolate flex h-fit flex-col">
      <img src={assets.governance.participateInDaoImagery} className="absolute top-0 left-0 w-full" />
      <div className="flex flex-col gap-8 p-6 pt-[60%] text-center">
        <div className="flex flex-col gap-4">
          <div className="typography-heading-3 text-primary-inverse">Participate in Spark Governance</div>
          <div className="typography-body-3 text-tertiary tracking-tight!">
            Participate in Spark Governance by voting on proposals or delegating your voting power and shape the future
            of Spark!
          </div>
        </div>
        <ExternalLinkButton to={links.docs.governance} variant="secondary" size="l" className="w-full">
          Learn more <ExternalLinkIcon className="icon-size-sm" />
        </ExternalLinkButton>
      </div>
    </Panel>
  )
}
